export default __webpack_public_path__ + "static/media/duque.a2143a03.mp4";